// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
._passwordDialog_joix2_2 {
	display: flex;
	flex-direction: column;
	gap: 10px 0;
	margin-inline: 6px;
	margin-block-end: 6px;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/password-confirmation/dist/style.css"],"names":[],"mappings":";AACA;CACC,aAAa;CACb,sBAAsB;CACtB,WAAW;CACX,kBAAkB;CAClB,qBAAqB;AACtB","sourcesContent":["\n._passwordDialog_joix2_2 {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 10px 0;\n\tmargin-inline: 6px;\n\tmargin-block-end: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
